import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class CustomIconService {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  init() {
    this.matIconRegistry.addSvgIcon('add_home', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/add-home.svg'));
    this.matIconRegistry.addSvgIcon(
      'apartment_outlined',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/apartment_outlined.svg')
    );
    this.matIconRegistry.addSvgIcon('attach_file', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/attach-file-icon.svg'));
    this.matIconRegistry.addSvgIcon('avatar', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/avatar-24px.svg'));
    this.matIconRegistry.addSvgIcon('block', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/block-icon.svg'));
    this.matIconRegistry.addSvgIcon('business', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/business-black-18dp.svg'));
    this.matIconRegistry.addSvgIcon(
      'charger_outlined',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/charging-station-outline-24px.svg')
    );
    this.matIconRegistry.addSvgIcon('charging_green', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/charging_green.svg'));
    this.matIconRegistry.addSvgIcon(
      'charging_orange',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/charging_orange.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'charging_orange_burnt',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/charging_orange_burnt.svg')
    );
    this.matIconRegistry.addSvgIcon('check_circle', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/check-circle.svg'));
    this.matIconRegistry.addSvgIcon('company_car', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/company-car.svg'));
    this.matIconRegistry.addSvgIcon('content_copy', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/content-copy.svg'));
    this.matIconRegistry.addSvgIcon('group', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/group-icon.svg'));
    this.matIconRegistry.addSvgIcon('handshake', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/handshake.svg'));
    this.matIconRegistry.addSvgIcon(
      'icon_transverse_discount',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/icon-transverse-discount.svg')
    );
    this.matIconRegistry.addSvgIcon('image', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/image-icon.svg'));
    this.matIconRegistry.addSvgIcon('keep', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/keep-icon.svg'));
    this.matIconRegistry.addSvgIcon('layers', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/layers-icon.svg'));
    this.matIconRegistry.addSvgIcon('move_down', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/move-down.svg'));
    this.matIconRegistry.addSvgIcon('note', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/note-32px.svg'));
    this.matIconRegistry.addSvgIcon('rfid_token', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/rfid-token.svg'));
    this.matIconRegistry.addSvgIcon('security', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/security-shield.svg'));
    this.matIconRegistry.addSvgIcon('sell', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/sell-24px.svg'));
    this.matIconRegistry.addSvgIcon('sell_outlined', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/sell-icon.svg'));
    this.matIconRegistry.addSvgIcon('settings', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/settings-icon.svg'));
    this.matIconRegistry.addSvgIcon('signpost', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/signpost.svg'));
    this.matIconRegistry.addSvgIcon(
      'socket_type_ccs2',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/socket-type-ccs2.svg')
    );
    this.matIconRegistry.addSvgIcon('socket_type2', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/socket-type2.svg'));
    this.matIconRegistry.addSvgIcon('price_change', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/price-change.svg'));
  }
}
